import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { UserRepository } from '../../domain/repository/user-repository';

@Injectable()
export default class UserDummyRepository implements UserRepository {
  create() {
    return Promise.resolve();
  }
}
